// Generated from internal/analytics/events by scripts/generate_analytics_events.
// This file is auto-generated. Do not edit manually.

export const AccountCreationPath = {
  CompleteSignup: 'complete_signup',
  CreateWithMember: 'create_with_member',
  EmailVerificationLegacy: 'email_verification_legacy',
  FacilitatedTrial: 'facilitated_trial',
  VerifiedMarketplaceAccount: 'verified_marketplace_account',
} as const;

export type AccountCreationPath = (typeof AccountCreationPath)[keyof typeof AccountCreationPath];

export const AgentControlOnboardingControlPath = {
  App: 'app',
  Sample: 'sample',
} as const;

export type AgentControlOnboardingControlPath = (typeof AgentControlOnboardingControlPath)[keyof typeof AgentControlOnboardingControlPath];

export const AgentControlOnboardingEvalsPath = {
  Code: 'code',
  Playground: 'playground',
} as const;

export type AgentControlOnboardingEvalsPath = (typeof AgentControlOnboardingEvalsPath)[keyof typeof AgentControlOnboardingEvalsPath];

export const AgentControlOnboardingExperience = {
  GoalChoice: 'goal-choice',
  SignupRedirect: 'signup-redirect',
  AutoSample: 'auto-sample',
  ChoiceScreen: 'choice-screen',
} as const;

export type AgentControlOnboardingExperience = (typeof AgentControlOnboardingExperience)[keyof typeof AgentControlOnboardingExperience];

export const AgentControlOnboardingGoal = {
  Evals: 'evals',
  Control: 'control',
  Other: 'other',
} as const;

export type AgentControlOnboardingGoal = (typeof AgentControlOnboardingGoal)[keyof typeof AgentControlOnboardingGoal];

export const AgentControlOnboardingStep = {
  Goal: 'goal',
  EvalsPath: 'evals-path',
  ControlPath: 'control-path',
  SomethingElse: 'something-else',
} as const;

export type AgentControlOnboardingStep = (typeof AgentControlOnboardingStep)[keyof typeof AgentControlOnboardingStep];

export const EnvironmentReleasePlanRowMenuAction = {
  Edit: 'edit',
  View: 'view',
  Clone: 'clone',
} as const;

export type EnvironmentReleasePlanRowMenuAction = (typeof EnvironmentReleasePlanRowMenuAction)[keyof typeof EnvironmentReleasePlanRowMenuAction];

export const ExperimentBuilderMode = {
  Simple: 'simple',
  Advanced: 'advanced',
} as const;

export type ExperimentBuilderMode = (typeof ExperimentBuilderMode)[keyof typeof ExperimentBuilderMode];

export const ExperimentBuilderResource = {
  Experiment: 'Experiment',
  MAB: 'MAB',
} as const;

export type ExperimentBuilderResource = (typeof ExperimentBuilderResource)[keyof typeof ExperimentBuilderResource];

export const ExperimentMetricStepHelpAction = {
  Docs: 'docs',
  TalkToPm: 'talk_to_pm',
  Dismiss: 'dismiss',
} as const;

export type ExperimentMetricStepHelpAction = (typeof ExperimentMetricStepHelpAction)[keyof typeof ExperimentMetricStepHelpAction];

export const ExperimentMetricStepHelpReason = {
  MetricFit: 'metric_fit',
  RecentValues: 'recent_values',
  MetricMissing: 'metric_missing',
  MetricTrust: 'metric_trust',
  Other: 'other',
} as const;

export type ExperimentMetricStepHelpReason = (typeof ExperimentMetricStepHelpReason)[keyof typeof ExperimentMetricStepHelpReason];

export const FlagCreationSurface = {
  WebUi: 'web_ui',
  Api: 'api',
  OauthApp: 'oauth_app',
  Terraform: 'terraform',
  Cli: 'cli',
  Automation: 'automation',
  Unknown: 'unknown',
} as const;

export type FlagCreationSurface = (typeof FlagCreationSurface)[keyof typeof FlagCreationSurface];

export const FlagVariationsPageVersion = {
  Legacy: 'legacy',
  Rewrite: 'rewrite',
} as const;

export type FlagVariationsPageVersion = (typeof FlagVariationsPageVersion)[keyof typeof FlagVariationsPageVersion];

export const HomeProduct = {
  Autopilot: 'autopilot',
  Guarded: 'guarded',
  Flags: 'flags',
  Experiments: 'experiments',
  Ai: 'ai',
  Observability: 'observability',
} as const;

export type HomeProduct = (typeof HomeProduct)[keyof typeof HomeProduct];

export const HomeResourceKind = {
  Flag: 'flag',
  Experiment: 'experiment',
} as const;

export type HomeResourceKind = (typeof HomeResourceKind)[keyof typeof HomeResourceKind];

export const InviteControlType = {
  Button: 'button',
  Link: 'link',
} as const;

export type InviteControlType = (typeof InviteControlType)[keyof typeof InviteControlType];

export const InviteVariant = {
  Drawer: 'drawer',
} as const;

export type InviteVariant = (typeof InviteVariant)[keyof typeof InviteVariant];

export const ProductSelectSource = {
  Picker: 'picker',
  WelcomePreselect: 'welcome-preselect',
} as const;

export type ProductSelectSource = (typeof ProductSelectSource)[keyof typeof ProductSelectSource];

export const ReleasePlanAdvancementMode = {
  Manual: 'manual',
  Automatic: 'automatic',
} as const;

export type ReleasePlanAdvancementMode = (typeof ReleasePlanAdvancementMode)[keyof typeof ReleasePlanAdvancementMode];

export const ReleasePlanCleanupBehavior = {
  LeaveRulesInPlace: 'leave_rules_in_place',
  RemoveRulesAndUpdateDefaultRule: 'remove_rules_and_update_default_rule',
} as const;

export type ReleasePlanCleanupBehavior = (typeof ReleasePlanCleanupBehavior)[keyof typeof ReleasePlanCleanupBehavior];

export const ReleaseSettingsTab = {
  EnvironmentReleasePlans: 'environment-release-plans',
  ReleasePolicies: 'release-policies',
  ReleaseAutomation: 'release-automation',
} as const;

export type ReleaseSettingsTab = (typeof ReleaseSettingsTab)[keyof typeof ReleaseSettingsTab];

export const SDKConnectionSource = {
  Server: 'server',
} as const;

export type SDKConnectionSource = (typeof SDKConnectionSource)[keyof typeof SDKConnectionSource];

export const SDKInstallMethod = {
  AiPrompt: 'aiPrompt',
  AgentDeepLink: 'agentDeepLink',
  Cli: 'cli',
  Cursor: 'cursor',
  DraftPr: 'draftPr',
  Snippet: 'snippet',
} as const;

export type SDKInstallMethod = (typeof SDKInstallMethod)[keyof typeof SDKInstallMethod];

export const SDKSetupConnectMethod = {
  Agent: 'agent',
  Cli: 'cli',
  Mcp: 'mcp',
} as const;

export type SDKSetupConnectMethod = (typeof SDKSetupConnectMethod)[keyof typeof SDKSetupConnectMethod];

export const SDKSetupSessionReplaySurface = {
  Agent: 'agent',
  Manual: 'manual',
} as const;

export type SDKSetupSessionReplaySurface = (typeof SDKSetupSessionReplaySurface)[keyof typeof SDKSetupSessionReplaySurface];

export const SegmentPendingChangesDrawerSource = {
  Toolbar: 'toolbar',
  Sidebar: 'sidebar',
} as const;

export type SegmentPendingChangesDrawerSource = (typeof SegmentPendingChangesDrawerSource)[keyof typeof SegmentPendingChangesDrawerSource];

export const SegmentScheduledChangeAuthorKind = {
  Member: 'member',
  ServiceToken: 'service_token',
} as const;

export type SegmentScheduledChangeAuthorKind = (typeof SegmentScheduledChangeAuthorKind)[keyof typeof SegmentScheduledChangeAuthorKind];

export const SegmentScheduledChangeOrigin = {
  Direct: 'direct',
  ApprovalRequest: 'approval_request',
} as const;

export type SegmentScheduledChangeOrigin = (typeof SegmentScheduledChangeOrigin)[keyof typeof SegmentScheduledChangeOrigin];

export const SegmentScheduledChangeStatus = {
  Pending: 'pending',
  InFlight: 'inFlight',
  Failed: 'failed',
} as const;

export type SegmentScheduledChangeStatus = (typeof SegmentScheduledChangeStatus)[keyof typeof SegmentScheduledChangeStatus];

export const SettingsSearchMatch = {
  Page: 'page',
  Heading: 'heading',
  Action: 'action',
  Synonym: 'synonym',
  Group: 'group',
} as const;

export type SettingsSearchMatch = (typeof SettingsSearchMatch)[keyof typeof SettingsSearchMatch];

export interface AnalyticsEventProps {
  'AgentControl Onboarding Arrived': {
    experience: AgentControlOnboardingExperience;
  };
  'AgentControl Onboarding Control Path Chosen': {
    path: AgentControlOnboardingControlPath;
  };
  'AgentControl Onboarding Engineer Call Clicked': {
    step: AgentControlOnboardingStep;
  };
  'AgentControl Onboarding Evals Path Chosen': {
    path: AgentControlOnboardingEvalsPath;
  };
  'AgentControl Onboarding Explore Clicked': {
    step: AgentControlOnboardingStep;
  };
  'AgentControl Onboarding Feedback Submitted': {
    topics: string[];
    hasDetails: boolean;
  };
  'AgentControl Onboarding Goal Chosen': {
    goal: AgentControlOnboardingGoal;
  };
  'Announcement banner created': undefined;
  'Announcement banner turned off': undefined;
  'Announcement banner updated': undefined;
  'App Signup Form Submitted': {
    visitedEnterpriseDemoTab?: boolean;
  };
  'Beast Mode SSO Redirected': {
    idpRedirectEnabled: boolean;
  };
  'Connect Method Tab Selected': {
    method: SDKSetupConnectMethod;
    previousMethod: SDKSetupConnectMethod;
    isDefault: boolean;
  };
  'Context Page Error Monitoring Setup Button Clicked': {
    projectKey: string;
  };
  'Context Page Session Replay Setup Button Clicked': {
    projectKey: string;
  };
  'Environment Release Plan Created': {
    projectKey: string;
    environmentKey: string;
    planKey: string;
    planVersion: number;
    phaseCount: number;
    advancementMode: ReleasePlanAdvancementMode;
    metricCount: number;
    metricGroupCount: number;
    cleanupBehavior: ReleasePlanCleanupBehavior;
    hasRandomizationUnit: boolean;
  };
  'Environment Release Plan Default Cleared': {
    projectKey: string;
    environmentKey: string;
    planKey: string;
  };
  'Environment Release Plan Default Set': {
    projectKey: string;
    environmentKey: string;
    planKey: string;
  };
  'Environment Release Plan Deleted': {
    projectKey: string;
    environmentKey: string;
    planKey: string;
    planVersion: number;
  };
  'Environment Release Plan Row Menu Item Clicked': {
    action: EnvironmentReleasePlanRowMenuAction;
    environmentKey: string;
  };
  'Environment Release Plan Updated': {
    projectKey: string;
    environmentKey: string;
    planKey: string;
    planVersion: number;
    phaseCount: number;
    advancementMode: ReleasePlanAdvancementMode;
    metricCount: number;
    metricGroupCount: number;
    cleanupBehavior: ReleasePlanCleanupBehavior;
    hasRandomizationUnit: boolean;
  };
  'Experiment Builder Mode Selected': {
    experimentId?: string;
    iterationId?: string;
    mode: ExperimentBuilderMode;
    type: ExperimentBuilderResource;
  };
  'Experiment Iteration Stopped (Server)': {
    experimentKey: string;
    experimentType: string;
    methodology: string;
    dataSource: string;
    projectKey: string;
    environmentKey: string;
    isExampleResource: boolean;
    iterationId?: string;
    startedIterationCount: number;
  };
  'Experiment Metric Step Help Clicked': {
    experimentId?: string;
    iterationId?: string;
    action: ExperimentMetricStepHelpAction;
  };
  'Experiment Metric Step Help Reason Submitted': {
    experimentId?: string;
    iterationId?: string;
    reason: ExperimentMetricStepHelpReason;
  };
  'Experiment Metric Step Stalled': {
    experimentId?: string;
    iterationId?: string;
    shown: boolean;
  };
  'First Experiment Iteration Started (Server)': {
    experimentKey: string;
    experimentType: string;
    methodology: string;
    dataSource: string;
    projectKey: string;
    environmentKey: string;
    isExampleResource: boolean;
    iterationId?: string;
    startedIterationCount: number;
  };
  'First SDK Connected': {
    userId: string;
    projectId: string;
    timestamp: number;
    source: SDKConnectionSource;
    serviceConnectionPurpose?: string;
    sdk?: string;
    source_surface?: string;
    provider?: string;
  };
  'Flag Variations Page Loaded': {
    pageVersion: FlagVariationsPageVersion;
  };
  'Home Page Viewed': undefined;
  'Home Product Selected': {
    product: HomeProduct;
    source: ProductSelectSource;
  };
  'Home Resource Created': {
    product: HomeProduct;
    stepId: string;
    resource: HomeResourceKind;
    resourceKey: string;
  };
  'Home Starter App Clicked': {
    product: HomeProduct;
  };
  'Metrics Table Exclude Button Clicked': {
    field: string;
  };
  'Metrics Table Filter Button Clicked': {
    field: string;
  };
  'New Account Created': {
    referer: string;
    firstName: string | null;
    lastName: string | null;
    organization: string | null;
    email: string;
    auth_method: string;
    path: AccountCreationPath;
    createdForJoinRequest?: boolean;
    ga_client_id?: string;
    ga_session_id?: string;
  } & Record<string, unknown>;
  'New Experiment Created (Server)': {
    experimentKey: string;
    experimentType: string;
    methodology: string;
    dataSource: string;
    projectKey: string;
    environmentKey: string;
    isExampleResource: boolean;
  };
  'New Feature Flag Created': {
    key: string;
    tagCount: number;
    flagPermanent: boolean;
    hasDescription: boolean;
    clientSdk: boolean;
    clientSdkEnvironmentId: boolean;
    clientSdkMobileKey: boolean;
    flagType: string;
    variationCount: number;
    defaultVariationsModified: boolean;
    creatorId: string | null;
    projectId: string;
    projectDefaultReleasePipelineKey: string;
    containsJiraIssue: boolean;
    viewAssociationRequired: boolean;
    isExampleResource: boolean;
    purpose?: string;
    stageCount?: number;
    contextKind?: string;
    customPropertyKeys?: string[];
    templateKey: string;
    templateName: string;
    usingFlagTemplate?: string[];
    overridingFlagTemplate?: string[];
    releasePipelineKey?: string;
    viewKeys?: string[];
    hasVariationJsonSchema: boolean;
    creationSurface: FlagCreationSurface;
  } & Record<string, unknown>;
  'New Member Added': {
    email: string;
    from_unverified_member?: boolean;
    auto_provisioned?: boolean;
  };
  'New Member Invited': {
    variant?: InviteVariant;
    component: string;
    type: InviteControlType;
    url: string;
    referrer: string;
    roleType?: string;
    organizationRole?: string;
    projectRoleCount?: number;
    initialRole?: string;
    numberOfInvitedMembers: number;
    teamCount: number;
  };
  'New Members Added': {
    count: number;
    memberIds: string[];
    teamCount: number;
  };
  'Release Pipeline Created': {
    audienceCount: number;
    phaseCount: number;
    environmentCounts: Record<string, number>;
    audiences: Array<{
      segmentCount: number;
      requireApproval: boolean;
      releaseStrategy: string;
    }>;
    pipelineKey: string;
    projectKey: string;
    isExampleResource: boolean;
  };
  'Release Pipeline Deleted': {
    pipelineKey: string;
    projectKey: string;
    isExampleResource: boolean;
  };
  'Release Plan Menu Dismissed': {
    planCount: number;
  };
  'Release Plan Menu Opened': {
    planCount: number;
  };
  'Release Settings Page Viewed': {
    tab: ReleaseSettingsTab;
  };
  'Release Settings Tab Selected': {
    tab: ReleaseSettingsTab;
    previousTab: ReleaseSettingsTab;
  };
  'Roadmap CTA Clicked': {
    product: HomeProduct;
    stepId: string;
    destination: string;
  };
  'Roadmap Step Viewed': {
    product: HomeProduct;
    stepId: string;
    required: boolean;
  };
  'SDK Connected': {
    userId: string;
    projectId: string;
    timestamp: number;
    source: SDKConnectionSource;
    serviceConnectionPurpose?: string;
    sdk?: string;
    source_surface?: string;
    provider?: string;
  };
  'SDK Install Initiated': {
    method: SDKInstallMethod;
  };
  'SDK Setup Completed': {
    sdk?: string;
    installMethod: string;
  };
  'SDK Setup Page Loaded': {
    method: string;
    connectTabDefault?: SDKSetupConnectMethod;
  };
  'SDK Setup Session Replay Toggled': {
    enabled: boolean;
    surface: SDKSetupSessionReplaySurface;
    sdk?: string;
  };
  'Segment Change Schedule Date Removed': undefined;
  'Segment Change Schedule Date Selected': undefined;
  'Segment Pending Changes Drawer Opened': {
    source: SegmentPendingChangesDrawerSource;
    scheduledChangeCount: number;
  };
  'Segment Scheduled Change Created': {
    instructionKinds: string[];
    authorKind: SegmentScheduledChangeAuthorKind;
    origin: SegmentScheduledChangeOrigin;
  };
  'Segment Scheduled Change Delete Opened': {
    status: SegmentScheduledChangeStatus;
  };
  'Segment Scheduled Change Deleted': {
    instructionKinds: string[];
    authorKind: SegmentScheduledChangeAuthorKind;
    origin: SegmentScheduledChangeOrigin;
  };
  'Segment Scheduled Change Edit Opened': undefined;
  'Segment Scheduled Change Updated': {
    instructionKinds: string[];
    authorKind: SegmentScheduledChangeAuthorKind;
    origin: SegmentScheduledChangeOrigin;
  };
  'Service Connection Discount Viewed': {
    planKey: string;
    version?: number;
    discountRate: number;
    discountedPrice: string;
  };
  'Settings Action Focused': {
    actionId: string;
    found: boolean;
    elapsedMs: number;
  };
  'Settings Search Action Result Clicked': {
    key: string;
    label: string;
    actionId: string;
    query: string;
    position: number;
    resultCount: number;
  };
  'Settings Search Page Result Clicked': {
    key: string;
    label: string;
    query: string;
    matchedOn: SettingsSearchMatch;
    position: number;
    resultCount: number;
  };
  'Signup Attempted': {
    auth_method: string;
    email_exists: boolean;
    existing_account_auth_method?: string;
    email_verified?: boolean;
    email_sent?: boolean;
  };
  'Signup Resolved As Login': {
    auth_method: string;
    existing_account_id: string;
  };
  'Signup Welcome Survey Completed': {
    reason: string;
    firstAction: string;
    jobRole: string;
    rotatingQuestionId?: string;
    rotatingQuestionAnswer?: string[];
    rotatingQuestionId2?: string;
    rotatingQuestionAnswer2?: string[];
    welcomeSurveyInviteApiKeyOwner?: boolean;
    welcomeSurveyInviteLinkCopied?: boolean;
    welcomeSurveyExistingCustomerIntent?: string;
    ga_client_id?: string;
    ga_session_id?: string;
  } & Record<string, unknown>;
  'Subsequent Experiment Iteration Started (Server)': {
    experimentKey: string;
    experimentType: string;
    methodology: string;
    dataSource: string;
    projectKey: string;
    environmentKey: string;
    isExampleResource: boolean;
    iterationId?: string;
    startedIterationCount: number;
  };
  'Welcome Survey Page Loaded': undefined;
  'patch_account': {
    fields?: string[];
    settingsSessionId?: string;
  };
  'patch_environment': {
    fields?: string[];
    settingsSessionId?: string;
  } & Record<string, unknown>;
  'patch_project': {
    fields?: string[];
    settingsSessionId?: string;
  };
}

export type AnalyticsEventName = keyof AnalyticsEventProps;

export type ClientAnalyticsEventName =
  | 'AgentControl Onboarding Arrived'
  | 'AgentControl Onboarding Control Path Chosen'
  | 'AgentControl Onboarding Engineer Call Clicked'
  | 'AgentControl Onboarding Evals Path Chosen'
  | 'AgentControl Onboarding Explore Clicked'
  | 'AgentControl Onboarding Feedback Submitted'
  | 'AgentControl Onboarding Goal Chosen'
  | 'App Signup Form Submitted'
  | 'Connect Method Tab Selected'
  | 'Context Page Error Monitoring Setup Button Clicked'
  | 'Context Page Session Replay Setup Button Clicked'
  | 'Environment Release Plan Row Menu Item Clicked'
  | 'Experiment Builder Mode Selected'
  | 'Experiment Metric Step Help Clicked'
  | 'Experiment Metric Step Help Reason Submitted'
  | 'Experiment Metric Step Stalled'
  | 'Flag Variations Page Loaded'
  | 'Home Page Viewed'
  | 'Home Product Selected'
  | 'Home Resource Created'
  | 'Home Starter App Clicked'
  | 'Metrics Table Exclude Button Clicked'
  | 'Metrics Table Filter Button Clicked'
  | 'New Member Invited'
  | 'Release Plan Menu Dismissed'
  | 'Release Plan Menu Opened'
  | 'Release Settings Page Viewed'
  | 'Release Settings Tab Selected'
  | 'Roadmap CTA Clicked'
  | 'Roadmap Step Viewed'
  | 'SDK Install Initiated'
  | 'SDK Setup Completed'
  | 'SDK Setup Page Loaded'
  | 'SDK Setup Session Replay Toggled'
  | 'Segment Change Schedule Date Removed'
  | 'Segment Change Schedule Date Selected'
  | 'Segment Pending Changes Drawer Opened'
  | 'Segment Scheduled Change Delete Opened'
  | 'Segment Scheduled Change Edit Opened'
  | 'Service Connection Discount Viewed'
  | 'Settings Action Focused'
  | 'Settings Search Action Result Clicked'
  | 'Settings Search Page Result Clicked'
  | 'Welcome Survey Page Loaded';

export const analyticsEventCategories: Record<AnalyticsEventName, string | undefined> = {
  'AgentControl Onboarding Arrived': 'AgentControl',
  'AgentControl Onboarding Control Path Chosen': 'AgentControl',
  'AgentControl Onboarding Engineer Call Clicked': 'AgentControl',
  'AgentControl Onboarding Evals Path Chosen': 'AgentControl',
  'AgentControl Onboarding Explore Clicked': 'AgentControl',
  'AgentControl Onboarding Feedback Submitted': 'AgentControl',
  'AgentControl Onboarding Goal Chosen': 'AgentControl',
  'Announcement banner created': 'AnnouncementBanner',
  'Announcement banner turned off': 'AnnouncementBanner',
  'Announcement banner updated': 'AnnouncementBanner',
  'App Signup Form Submitted': 'Login Form',
  'Beast Mode SSO Redirected': undefined,
  'Connect Method Tab Selected': 'SDK Setup',
  'Context Page Error Monitoring Setup Button Clicked': 'Observability',
  'Context Page Session Replay Setup Button Clicked': 'Observability',
  'Environment Release Plan Created': 'Environment Release Plans',
  'Environment Release Plan Default Cleared': 'Environment Release Plans',
  'Environment Release Plan Default Set': 'Environment Release Plans',
  'Environment Release Plan Deleted': 'Environment Release Plans',
  'Environment Release Plan Row Menu Item Clicked': 'Environment Release Plans',
  'Environment Release Plan Updated': 'Environment Release Plans',
  'Experiment Builder Mode Selected': 'Flag Experiments',
  'Experiment Iteration Stopped (Server)': 'Flag Experiments',
  'Experiment Metric Step Help Clicked': 'Flag Experiments',
  'Experiment Metric Step Help Reason Submitted': 'Flag Experiments',
  'Experiment Metric Step Stalled': 'Flag Experiments',
  'First Experiment Iteration Started (Server)': 'Flag Experiments',
  'First SDK Connected': undefined,
  'Flag Variations Page Loaded': 'Flags',
  'Home Page Viewed': 'Home Page',
  'Home Product Selected': 'Home Page',
  'Home Resource Created': 'Home Page',
  'Home Starter App Clicked': 'Home Page',
  'Metrics Table Exclude Button Clicked': 'Observability',
  'Metrics Table Filter Button Clicked': 'Observability',
  'New Account Created': undefined,
  'New Experiment Created (Server)': 'Flag Experiments',
  'New Feature Flag Created': undefined,
  'New Member Added': undefined,
  'New Member Invited': 'Manage Member',
  'New Members Added': undefined,
  'Release Pipeline Created': 'Release Pipelines',
  'Release Pipeline Deleted': 'Release Pipelines',
  'Release Plan Menu Dismissed': 'Release Builder',
  'Release Plan Menu Opened': 'Release Builder',
  'Release Settings Page Viewed': 'Environment Release Plans',
  'Release Settings Tab Selected': 'Environment Release Plans',
  'Roadmap CTA Clicked': 'Home Page',
  'Roadmap Step Viewed': 'Home Page',
  'SDK Connected': undefined,
  'SDK Install Initiated': 'SDK Setup',
  'SDK Setup Completed': 'SDK Setup',
  'SDK Setup Page Loaded': 'SDK Setup',
  'SDK Setup Session Replay Toggled': 'SDK Setup',
  'Segment Change Schedule Date Removed': 'Scheduled Changes',
  'Segment Change Schedule Date Selected': 'Scheduled Changes',
  'Segment Pending Changes Drawer Opened': 'Scheduled Changes',
  'Segment Scheduled Change Created': 'Scheduled Changes',
  'Segment Scheduled Change Delete Opened': 'Scheduled Changes',
  'Segment Scheduled Change Deleted': 'Scheduled Changes',
  'Segment Scheduled Change Edit Opened': 'Scheduled Changes',
  'Segment Scheduled Change Updated': 'Scheduled Changes',
  'Service Connection Discount Viewed': 'Billing',
  'Settings Action Focused': 'Settings',
  'Settings Search Action Result Clicked': 'Settings',
  'Settings Search Page Result Clicked': 'Settings',
  'Signup Attempted': undefined,
  'Signup Resolved As Login': undefined,
  'Signup Welcome Survey Completed': undefined,
  'Subsequent Experiment Iteration Started (Server)': 'Flag Experiments',
  'Welcome Survey Page Loaded': 'Welcome Survey',
  'patch_account': undefined,
  'patch_environment': undefined,
  'patch_project': undefined,
};
